import { useState } from "react";
import { Map, Hotel, Plane, Car, Sun, Compass, Globe, Star, Navigation, Clock, ExternalLink } from "lucide-react";

const TRAVEL_TOOLS = [
  { name: "Google Maps", icon: Map, url: "https://maps.google.com", color: "bg-green-600" },
  { name: "Booking.com", icon: Hotel, url: "https://www.booking.com", color: "bg-blue-700" },
  { name: "Expedia", icon: Plane, url: "https://www.expedia.com", color: "bg-yellow-600" },
  { name: "Hotels.com", icon: Hotel, url: "https://www.hotels.com", color: "bg-red-600" },
  { name: "Kayak", icon: Navigation, url: "https://www.kayak.com", color: "bg-orange-600" },
  { name: "TripAdvisor", icon: Star, url: "https://www.tripadvisor.com", color: "bg-emerald-600" },
  { name: "Airbnb", icon: Hotel, url: "https://www.airbnb.com", color: "bg-pink-600" },
  { name: "Rental Cars", icon: Car, url: "https://www.rentalcars.com", color: "bg-purple-600" },
  { name: "Weather.com", icon: Sun, url: "https://www.weather.com", color: "bg-sky-600" },
  { name: "Google Flights", icon: Plane, url: "https://www.google.com/flights", color: "bg-indigo-600" },
  { name: "World Clock", icon: Clock, url: "https://www.timeanddate.com/worldclock/", color: "bg-gray-600" },
  { name: "Rome2Rio", icon: Compass, url: "https://www.rome2rio.com", color: "bg-teal-600" },
];

const TravelToolsPanel = ({ roomId }) => {
  // Only show in travel room
  if (roomId !== "travel") return null;

  const openTool = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="retro-window mb-2" data-testid="travel-tools-panel">
      <div className="retro-title-bar px-2 py-1">
        <span className="flex items-center gap-1">
          <Globe className="w-4 h-4" />
          ✈️ TRAVEL TOOLS
        </span>
      </div>

      <div className="p-2 bg-gradient-to-b from-sky-100 to-blue-100 max-h-[300px] overflow-y-auto retro-scrollbar">
        {/* Compact Tool List */}
        <div className="space-y-1">
          {TRAVEL_TOOLS.map((tool, index) => {
            const Icon = tool.icon;
            return (
              <button
                key={index}
                className={`${tool.color} hover:opacity-90 text-white rounded w-full p-1.5 transition-all flex items-center gap-2 text-xs`}
                onClick={() => openTool(tool.url)}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="font-bold truncate">{tool.name}</span>
                <ExternalLink className="w-3 h-3 ml-auto flex-shrink-0 opacity-70" />
              </button>
            );
          })}
        </div>

        {/* Quick Search */}
        <div className="mt-2 bg-white rounded p-2 border border-blue-300">
          <input
            type="text"
            placeholder="🔍 Search destination..."
            className="w-full px-2 py-1 border border-gray-300 rounded text-xs"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && e.target.value) {
                window.open(`https://www.google.com/search?q=${encodeURIComponent(e.target.value + ' travel guide')}`, '_blank');
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TravelToolsPanel;
